const isBrowser = typeof window !== 'undefined'
const isStaticGeneration = typeof window === 'undefined' && process.env.NODE_ENV === 'production'

class DatadogSingleton {
  private static instance: DatadogSingleton
  private isInitialized = false
  public logs: any = null
  public rum: any = null

  private constructor() {}

  public static getInstance(): DatadogSingleton {
    if (!DatadogSingleton.instance) {
      DatadogSingleton.instance = new DatadogSingleton()
    }
    return DatadogSingleton.instance
  }

  public async initialize() {
    // Don't initialize during static generation or non-browser environments
    if (!isBrowser || isStaticGeneration) return
    if (this.isInitialized) return

    try {
      // Dynamically import Datadog SDKs
      const [{ datadogLogs }, { datadogRum }] = await Promise.all([
        import('@datadog/browser-logs'),
        import('@datadog/browser-rum'),
      ])

      this.logs = datadogLogs
      this.rum = datadogRum

      const applicationId = process.env.NEXT_PUBLIC_DATADOG_APP_ID
      const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN
      const datadogEnv = process.env.NEXT_PUBLIC_DATADOG_ENV
      const appUrl = process.env.APP_URL ?? process.env.NEXT_PUBLIC_APP_URL
      const sessionReplayRate = Number(process.env.NEXT_PUBLIC_DATADOG_SESSION_REPLAY_RATE) || 20
      const sessionSampleRate = Number(process.env.NEXT_PUBLIC_DATADOG_SESSION_SAMPLE_RATE) || 10

      if (!applicationId || !clientToken || !datadogEnv || !appUrl || !sessionReplayRate || !sessionSampleRate) {
        throw new Error('Datadog configuration missing - required environment variables are not set')
      }

      datadogRum.init({
        applicationId,
        clientToken,
        site: 'datadoghq.com',
        service: `scalis-${datadogEnv}-fe`,
        env: datadogEnv,
        sessionSampleRate: datadogEnv === 'prod' ? sessionSampleRate : 10,
        sessionReplaySampleRate: datadogEnv === 'prod' ? sessionReplayRate : 0,
        trackSessionAcrossSubdomains: true,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'allow',
        allowedTracingUrls: [appUrl],
        enableExperimentalFeatures: ['logs'],
      })

      datadogLogs.init({
        clientToken,
        site: 'datadoghq.com',
        service: `scalis-${datadogEnv}-fe`,
        env: datadogEnv,
        sendLogsAfterSessionExpiration: true,
        trackSessionAcrossSubdomains: true,
        forwardErrorsToLogs: false,
      })

      this.isInitialized = true
    } catch (error) {
      // Use the logger if available, otherwise fall back to console
      if (this.logs) {
        this.logs.logger.error('Failed to initialize Datadog:', error)
      } else {
        // eslint-disable-next-line no-console
        console.error('Failed to initialize Datadog:', error)
      }
    }
  }
}

export const Datadog = DatadogSingleton.getInstance()
